import { ca } from '@cian/analytics';

import { MORTGAGE_PROMO_TYPES } from '../../../constants/promos';
import { getProductsData } from '../../../selectors/analytics/builder';
import { IPromoInfoSchema } from '../../../types/promo';

export function trackShowPhone(customPageURL: string, promo: IPromoInfoSchema, newbuildingId: number) {
  const { promoType, promoId } = promo;

  const isMortgage = MORTGAGE_PROMO_TYPES.includes(promo.promoType);

  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: isMortgage ? 'Open_jk_mortgage' : 'Open_jk_promotions',
    label: customPageURL,
    products: [getProductsData(newbuildingId, null, { label: promoType, promotion_id: promoId })],
  });
}
